import { render, staticRenderFns } from "./UpcomingFeatures.vue?vue&type=template&id=7c40e446&scoped=true&"
import script from "./UpcomingFeatures.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpcomingFeatures.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c40e446",
  null
  
)

export default component.exports